import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Hash targets mount up to ~350ms after navigation (AnimatePresence mode="wait"),
// so poll for the element instead of scrolling immediately.
const HASH_SCROLL_TIMEOUT_MS = 2000

export function useScrollManager() {
  const { key, hash } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      return
    }
    const id = decodeURIComponent(hash.slice(1))
    const deadline = performance.now() + HASH_SCROLL_TIMEOUT_MS
    let rafId = 0
    const tryScroll = () => {
      const el = document.getElementById(id)
      if (el) {
        // CSS scroll-behavior + scroll-padding-top handle easing and nav offset
        el.scrollIntoView()
      } else if (performance.now() < deadline) {
        rafId = requestAnimationFrame(tryScroll)
      }
    }
    tryScroll()
    return () => cancelAnimationFrame(rafId)
  }, [key, hash])
}
